import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { FC, useMemo } from "react"
import { CompanyRequest, companyRequestReadableTypes } from "src/apis/company_requests"
import NoDataAlert from "src/pages/components/NoDataAlert"
import { formatDateToBR } from "src/utils/date"
import CompanyRequestsTableMessageCell from "./CompanyRequestsTableMessageCell"
import CompanyRequestsTableResolvedCell from "./CompanyRequestsTableResolvedCell"

type CompanyRequestsTableProps = {
  companyRequests: CompanyRequest[],
  setError: (err: string) => void,
}

const CompanyRequestsTable: FC<CompanyRequestsTableProps> = ({companyRequests, setError}): JSX.Element => {
  const hasCompanyRequests = useMemo(() => Boolean(companyRequests) && companyRequests.length > 0, [companyRequests])

  return hasCompanyRequests ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Empresa</strong></TableCell>
            <TableCell><strong>Tipo</strong></TableCell>
            <TableCell><strong>Resolvido</strong></TableCell>
            <TableCell><strong>Mensagem</strong></TableCell>
            <TableCell><strong>Solicitado Por</strong></TableCell>
            <TableCell><strong>Solicitado Para</strong></TableCell>
            <TableCell><strong>Criado Em</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {companyRequests?.map((companyRequest: CompanyRequest) => (
            <TableRow key={`request_row_${companyRequest?.id}`}>
              <TableCell>{companyRequest?.id}</TableCell>
              <TableCell>{companyRequest?.solicitado_pela_empresa_nome}</TableCell>
              <TableCell>{companyRequestReadableTypes[companyRequest?.tipo]}</TableCell>
              <TableCell>
                <CompanyRequestsTableResolvedCell
                  companyRequestId={companyRequest?.id}
                  resolved={companyRequest?.resolvido}
                  setError={setError}
                />
              </TableCell>
              <TableCell>
                <CompanyRequestsTableMessageCell
                  message={companyRequest?.mensagem}
                />
              </TableCell>
              <TableCell>{companyRequest?.solicitado_pelo_usuario_nome}</TableCell>
              <TableCell>{companyRequest?.solicitado_para_colaboradores?.join(", ")}</TableCell>
              <TableCell>{formatDateToBR(companyRequest?.criado_em)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataAlert />
  );
}

export default CompanyRequestsTable;
